import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import {
  ConsumptionReport,
  InventoryValuationReport,
  MarginReport,
  WasteReport,
} from "./inventory.type";

export interface DateRangeParams {
  from?: string;
  to?: string;
}

export const InventoryReportApi = createApi({
  reducerPath: "inventoryReportApi",
  tagTypes: ["inventoryReport"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getInventoryValuation: build.query<
      InventoryValuationReport,
      { restaurantId: string }
    >({
      query: ({ restaurantId }) =>
        `restaurants/${restaurantId}/inventory/valuation`,
      providesTags: ["inventoryReport"],
    }),

    getInventoryConsumption: build.query<
      ConsumptionReport,
      { restaurantId: string; query?: DateRangeParams }
    >({
      query: ({ restaurantId, query }) => ({
        url: `restaurants/${restaurantId}/inventory/reports/consumption`,
        method: "GET",
        params: query,
      }),
      providesTags: ["inventoryReport"],
    }),

    getInventoryWaste: build.query<
      WasteReport,
      { restaurantId: string; query?: DateRangeParams }
    >({
      query: ({ restaurantId, query }) => ({
        url: `restaurants/${restaurantId}/inventory/reports/waste`,
        method: "GET",
        params: query,
      }),
      providesTags: ["inventoryReport"],
    }),

    getInventoryMargin: build.query<MarginReport, { restaurantId: string }>({
      query: ({ restaurantId }) =>
        `restaurants/${restaurantId}/inventory/reports/margin`,
      providesTags: ["inventoryReport"],
    }),
  }),
});

export const {
  useGetInventoryValuationQuery,
  useGetInventoryConsumptionQuery,
  useGetInventoryWasteQuery,
  useGetInventoryMarginQuery,
} = InventoryReportApi;
